import { render, staticRenderFns } from "./ObligeeForm.vue?vue&type=template&id=580d0cb5&scoped=true"
import script from "./ObligeeForm.vue?vue&type=script&lang=js"
export * from "./ObligeeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d0cb5",
  null
  
)

export default component.exports